import { Box, Text } from '@zillow/constellation-10';
import type { PercentageDatum } from '../RenterDataReport.utils';
import { formatNumber } from '../../../../../utils';
import { roundUp } from '../../../../../utils/roundUp';

const PRIMARY_BAR_COLOR = '#891EFA';

type StackedBarListProps = {
  data: Array<PercentageDatum>;
};

export const StackedBarList = ({ data }: StackedBarListProps) => {
  const maxValue = Math.max(...data.map((item) => item.value), 1);
  const scale = Math.ceil(maxValue / 10) * 10 || 10;
  const labelThreshold = (scale * 15) / 100;

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: '300' }}>
      {data.map((item) => {
        const barWidth = (item.value / maxValue) * 100;
        const isSmall = item.value < labelThreshold;
        return (
          <Box key={item.label} css={{ display: 'flex', flexDirection: 'column', gap: '100' }}>
            <Text textStyle="body-sm" css={{ color: 'text.subtle' }}>
              {item.label}
            </Text>
            <Box css={{ display: 'flex', alignItems: 'center', gap: '200' }}>
              <Box
                style={{ width: `${barWidth}%` }}
                css={{
                  backgroundColor: PRIMARY_BAR_COLOR,
                  height: '28px',
                  borderRadius: '4px',
                  minWidth: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: isSmall ? '0' : '300',
                }}
              >
                {!isSmall && (
                  <Text textStyle="body-sm-bold" css={{ color: 'white', whiteSpace: 'nowrap' }}>
                    {formatNumber(roundUp(Number(item.value), 1))}%
                  </Text>
                )}
              </Box>
              {isSmall && (
                <Text textStyle="body-sm-bold" css={{ color: 'text.primary' }}>
                  {formatNumber(roundUp(Number(item.value), 1))}%
                </Text>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
